<template>
  <div class="bono-comision">
    <form @submit.prevent="addBono()">
      <div class="bono-comision__new">
        <div class="bono-comision__new-selector">
          <label>
            <input type="radio" :value="undefined" v-model="origin">
            <span>Remuneraciones Variables</span>
          </label>
          <label>
            <input type="radio" value="other-5ta" v-model="origin">
            <span>Rentas Otros 5ta Categoria</span>
          </label>

        </div>


        <md-field v-if="origin === 'other-5ta'">
          <label>RUC de otro empleador</label>
          <md-input v-model="ruc"></md-input>
        </md-field>

        <md-field>
          <label>Descripción</label>
          <md-input required v-model="description"></md-input>
        </md-field>
        <!-- conceptos de pago -->

        <md-autocomplete v-model="conceptSelected" :md-options="myConceptsRemunerations" md-dense @md-selected="selectBuyConcept"
          v-if="origin === undefined">
          <label>Concepto de pago</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">
            <div>
              <p class="text-ellipsis">{{item.name}}</p>
              <p>{{ item.alias }}</p>
            </div>
          </template>
        </md-autocomplete>

        <md-field v-if="isExtraHours">
          <label>Cantidad de Horas</label>
          <md-input :required="isExtraHours" v-model="hours"></md-input>
        </md-field>

        <md-field v-if="isExtraHours">
          <label>Cantidad de Minutos</label>
          <md-input :required="isExtraHours" v-model="minutes"></md-input>
        </md-field>

        <md-field>
          <label>Fecha de asignación</label>
          <v-date-picker v-model="date" class="datepick" :formats="formats" popover-visibility="focus"
            :max-date="new Date()">
            <!-- :min-date="minDate" -->
            <!-- OJO -->
            <md-input slot-scope="{ inputValue }" style="text-align: left !important" :value="inputValue | formatDate"
              readonly></md-input>
          </v-date-picker>
        </md-field>

        <md-field>
          <label>Monto</label>
          <md-input required v-model="value"></md-input>
        </md-field>

        <md-button type="submit" class="md-raised md-primary" v-if="show">Agregar</md-button>
      </div>
    </form>

    <div class="bono-comision__separator"></div>

    <div class="bono-comision__history">
      <div class="bono-comision__detail" v-for="(item, index) in bonosCommi" :key="index">
        <i class="icon-close" @click="deleteThis(item.id)" v-if="show"></i>
        <div class="bono-comision__detail-date">
          {{ item.date | formatDateHistory }}
        </div>
        <div class="bono-comision__detail-description">
          <span>{{ item.description }}</span>
          <span class="concept">{{ item.concept ? item.concept.name : `RENTA OTRO EMPLEADOR - ${item.ruc}` }}</span>
        </div>
        <div class="bono-comision__detail-monto">
          {{ item.value | currency }}
        </div>
      </div>
    </div>
    <div class="commision__footer" v-if="pages > 1">
      <paginate v-model="page" :pageCount="pages" :prev-text="'p'" :next-text="'q'" :containerClass="'pagination'"
        :page-class="'page-item'" :clickHandler="changePages"></paginate>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";
// import { required } from 'vuelidate/lib/validators';
export default {
  name: "Remuneraciones-var",
  components: {
    Paginate,
  },
  data() {
    return {
      description: "",
      date: null,
      value: null,
      type: "",
      formats: {
        input: "D MMM YYYY",
      },
      conceptSelected: null,
      concept: null,
      conceptCode: null,
      bonosCommi: [],
      pages: 1,
      page: 1,
      origin: undefined,
      ruc: null,
      hours: null,
      minutes: null
      // type: undefined
      //bonos y comisiones
      // bonos: []
    };
  },
  created() {
    this.$store.dispatch("getCommissionList", this.$route.params.id);
    this.getDetailBusiness(this.$store.state.business.businessId).then((r) => {
      if (r.status == 200) {
        console.log("conceptos propios obtenidos");
        this.$store
          .dispatch("getEmployeeConceptsVar", {
            id: this.$route.params.id,
            page: this.page,
          })
          .then((res) => {
            if (res.status == 200) {
              this.bonosCommi = res.data.results;
              this.page = res.data.currentPage;
              this.pages = res.data.totalPages;
              console.log(res.data);
            }
          });
      }
    });
  },
  activated() {
    this.page = 1;
    this.$store.dispatch("getCommissionList", this.$route.params.id);
    this.$store
      .dispatch("getEmployeeConceptsVar", { id: this.$route.params.id, page: this.page })
      .then((res) => {
        if (res.status == 200) {
          this.bonosCommi = res.data.results;
          this.page = res.data.currentPage;
          this.pages = res.data.totalPages;
          console.log(res.data);
        }
      });
  },
  computed: {
    ...mapGetters({
      myConceptsRemunerations: "myConceptsRemunerations",
    }),
    // myConcepts(){
    //   if(!this.$store.state.business.personalConcepts) return []
    //   return this.$store.state.business.personalConcepts.map(item => {
    //     return {
    //       name: item.concept.name,
    //       id: item.concept.id
    //     }
    //   })
    // },
    bonos() {
      return this.$store.getters.listCommission.filter(
        (b) => b.type == "commission" || b.type == "bonus"
      );
    },

    minDate() {
      return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    },
    show() {
      return ["owner", "master", "manager", "normal"].includes(
        this.$store.getters.roleIn
      );
    },
    isExtraHours() {
      return ["105", "106"].includes(this.conceptCode)
    }
  },
  filters: {
    formatDate(value) {
      let splitStr = value.split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        if (i == 1)
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() +
            splitStr[i].substring(1, splitStr[i].length - 1);
      }
      return splitStr.join(" ");
    },

    formatDateHistory(value) {
      let valueDate = new Date(value);
      let month = "";
      switch (valueDate.getMonth()) {
        case 0:
          month = "Ene";
          break;
        case 1:
          month = "Feb";
          break;
        case 2:
          month = "Mar";
          break;
        case 3:
          month = "Abr";
          break;
        case 4:
          month = "May";
          break;
        case 5:
          month = "Jun";
          break;
        case 6:
          month = "Jul";
          break;
        case 7:
          month = "Ago";
          break;
        case 8:
          month = "Sept";
          break;
        case 9:
          month = "Oct";
          break;
        case 10:
          month = "Nov";
          break;
        case 11:
          month = "Dic";
          break;
      }
      return valueDate.getDate() + " " + month + " " + valueDate.getFullYear();
    },

    toSoles(value) {
      return `S/. ${Number(value).toFixed(2)}`;
    },
  },

  methods: {
    ...mapActions({
      getDetailBusiness: "getDetailBusiness",
    }),

    addBono() {
      let body = {}
      if (this.origin === undefined) {
        body = {
          description: this.description,
          date: new Date(this.date).toISOString(),
          value: Number(this.value),
          type: this.type,
          concept: this.concept,
          conceptCode: this.conceptCode,
          ruc: this.ruc,
          hours: this.hours,
          minutes: this.minutes
        }
      } else {
        body = {
          ruc: this.ruc,
          date: new Date(this.date).toISOString(),
          value: Number(this.value),
          description: this.description,
        }
      }
      this.$store
        .dispatch("setCommission", {
          id: this.$route.params.id,
          body: body,
        })
        .then((res) => {
          if (res.status == 200) {
            this.$store
              .dispatch("getEmployeeConceptsVar", {
                id: this.$route.params.id,
                page: this.page,
              })
              .then((res) => {
                if (res.status == 200) {
                  this.bonosCommi = res.data.results;
                  this.page = res.data.currentPage;
                  this.pages = res.data.totalPages;
                  this.description = "";
                  this.date = null;
                  this.value = null;
                  this.type = "";
                  this.concept = null;
                  this.conceptCode = null;
                  this.conceptSelected = null;
                }
              });
          }
        });
      //cleaning
    },

    deleteThis(id) {
      console.log("id: ", id);
      this.$store.dispatch("deleteCommission", id).then((res) => {
        if (res.status == 200) {
          console.log("bono eliminado :c");
          this.$store
            .dispatch("getEmployeeConceptsVar", {
              id: this.$route.params.id,
              page: this.page,
            })
            .then((res) => {
              console.log("lista de bonos actualizados");
              this.bonosCommi = res.data.results;
              this.page = res.data.currentPage;
              this.pages = res.data.totalPages;
              this.description = "";
              this.date = null;
              this.value = null;
              this.type = "";
              this.concept = null;
              this.conceptCode = null;
              this.conceptSelected = null;
            });
        }
      });
    },

    selectBuyConcept(value) {
      console.log(value);
      this.conceptSelected = value.name;
      this.concept = value.id;
      this.conceptCode = value.code;
    },
    changePages(value) {
      this.$store
        .dispatch("getEmployeeConceptsVar", { id: this.$route.params.id, page: value })
        .then((res) => {
          if (res.status == 200) {
            this.bonosCommi = res.data.results;
            this.page = res.data.currentPage;
            this.pages = res.data.totalPages;
            console.log(res.data);
          }
        });
    },
  },
  watch: {
    conceptSelected: function (n) {
      if (!n) {
        this.concept = null;
        this.conceptCode = null;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}

//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS
.md-field,
.md-button {
  width: 18rem;

  @include mq($sm) {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

.md-menu-content {
  max-width: none;
}

.bono-comision {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  padding-bottom: 3rem;

  &__new {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    width: 100%;

    @include mq($sm) {
      flex-direction: row;
      justify-content: center;
    }
  }

  .bono-comision__new-selector {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.5em;
    width: 100%;
    margin: 1rem auto;
    align-items: center;

    @include mq($sm) {
      flex-flow: row nowrap;
      justify-content: center;
    }

    & label {
      margin: 0.5rem 1.25rem;
      cursor: pointer;

      & input {
        margin-right: 0.5rem;
      }
    }
  }

  &__separator {
    height: 1px;
    width: 100%;
    background-color: rgba($b-blue, 0.3);
    margin: 2rem 0;
  }

  &__history {
    border-radius: 9px;
    border: 1px solid rgba($b-blue, 0.3);
    border-left: 3px solid $b-orange;
    overflow: hidden;
  }

  &__detail {
    height: 5rem;
    border: 1px solid rgba($b-blue, 0.2);
    width: 24rem;
    display: flex;
    padding-left: 1rem;
    position: relative;

    @include mq($sm) {
      width: 36rem;
    }

    .icon-close {
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
      color: $b-orange;
      font-size: 1.2rem;

      @include mq($md) {
        cursor: pointer;
      }
    }

    &-date {
      width: 2.5rem;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    &-description {
      margin-left: 2rem;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      color: rgba($b-blue, 0.75);

      span {
        // width: 9rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      @include mq($sm) {
        width: 21rem;
      }
    }

    &-monto {
      margin-left: 2rem;
      display: flex;
      align-items: center;
      font-weight: 500;
    }
  }
}

.concept {
  font-size: 0.9rem;
  color: #adadad;
}</style>
<style>
.text-ellipsis {
  text-overflow: ellipsis;
}
</style>